import React, { useState, useEffect } from "react";
import "./Header.css";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // Control Navbar expanded state

  const handleNavClick = () => setExpanded(false); // Close Navbar on Nav.Link click

  const [isScrolled, setIsScrolled] = useState(false); // Track scroll state

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className={`Header ${isScrolled ? "bg_white_holder" : ""}`}>
        <div className="container">
          {/* <div className="Header_holder">
            <div className="icon-text-holder">
              <div className="icon-holder ">
                <FontAwesomeIcon className="icon" icon={faPhone} />
              </div>
              <p>Toll-Free: 1800-268-2424</p>
            </div>
          </div> */}
          <div className="menu-header-holder desktop-view-toggle-menubar">
            <div className="">
              <Navbar
                expand="lg"
                className="menu-header"
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
              >
                <Navbar.Brand href="#home">
                  <div className="logo-holder">
                    <Link to={"/"}>
                      <img
                        className="logo-img"
                        src={
                          process.env.PUBLIC_URL +
                          "/Assets/Images/logo/logo.png"
                        }
                        alt="reach_out_logo"
                      />
                    </Link>
                  </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                  <Nav className="ms-auto my-2 my-lg-0">
                    <Nav.Link
                      as={Link}
                      to={"/"}
                      className={location.pathname === "/" ? "active" : ""}
                      onClick={handleNavClick}
                    >
                      HOME
                    </Nav.Link>

                    {/* <Nav.Item className="nav-item-with-submenu">
                      <Nav.Link
                        as={Link}
                        to="/about-us"
                        className={
                          location.pathname === "/about-us"
                            ? "active"
                            : "about_nav_drop"
                        }
                        onClick={handleNavClick}
                      >
                        ABOUT US
                      </Nav.Link>

                      <div className="submenu ">
                        <Link to="/leaderShip">
                          <div className="menu_div">LEADERSHIP</div>
                        </Link>
                      </div>
                    </Nav.Item> */}

                    <Dropdown className="about_dropdown">
                      <Dropdown.Toggle className="nav-link" id="dropdown-basic"  as={Link}
                        to="/about-us">
                        ABOUT US
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to="/leaderShip">
                          LEADERSHIP
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* <Nav.Link
                      as={Link}
                      to={"/leaderShip"}
                      className={
                        location.pathname === "/leaderShip"
                          ? "active mobile_menu_leaderShip"
                          : " mobile_menu_leaderShip"
                      }
                      onClick={handleNavClick}
                    >
                      LEADERSHIP
                    </Nav.Link> */}

                    <Nav.Link
                      as={Link}
                      to={"/services"}
                      className={
                        location.pathname === "/services" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      SERVICES
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/career"}
                      className={
                        location.pathname === "/career" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      CAREERS
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to={"/contact-us"}
                      className={
                        location.pathname === "/contact-us" ? "active" : ""
                      }
                      onClick={handleNavClick}
                    >
                      CONTACT US
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
